import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Effort } from '../_models/effort';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class EffortService extends ApiService {
  constructor(private http: Http) {
    super('api/efforts/', http);
  }

  create(effort: Effort): Observable<Effort> {
    return this.http
      .post(this.apiUrl + this.endpointUrl, JSON.stringify(effort), { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  update(effort: Effort): Observable<Effort> {
    const url = `${this.apiUrl + this.endpointUrl}${effort.id}/`;
    return this.http.put(url, JSON.stringify(effort), { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }

  delete(id: number): Observable<void> {
    const url = `${this.apiUrl + this.endpointUrl}${id}/`;
    return this.http.delete(url, { headers: this.getHeaders() }).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/effort.service.ts